(function () {
  var roots = Array.prototype.slice.call(document.querySelectorAll('[data-hs-garage-header-notifications]'));
  if (!roots.length) return;

  var storageKey = 'hsGarageDismissedNotifications';
  var notifications = [];
  var garageLinks = [];
  var garageLoaded = false;
  var garageLoading = false;
  var menuStyle = document.createElement('style');
  menuStyle.textContent = '.hs-garage-header-alert__panel{max-width:calc(100vw - 24px)}.hs-garage-menu{padding:12px;display:grid;gap:8px}.hs-garage-menu a,.hs-garage-menu summary{display:flex!important;align-items:center;gap:12px;padding:14px!important;background:#f3f4f6!important;color:#222831!important;border:1px solid #e1e4e8;border-radius:10px;text-decoration:none!important;font-size:14px!important;font-weight:700!important;cursor:pointer;line-height:1.4}.hs-garage-menu a:hover,.hs-garage-menu summary:hover{border-color:#dc1125;background:#fff!important}.hs-garage-menu i{display:grid;place-items:center;flex:0 0 32px;height:32px;border-radius:8px;background:#252a31;color:white;font-style:normal;font-size:19px}.hs-garage-menu .hs-garage-menu-edit i{background:#dc1125}.hs-garage-menu summary{list-style:none}.hs-garage-menu details>a{margin-top:6px;font-size:12px!important}.hs-garage-menu small{font-size:11px;display:block;font-weight:400;color:#69727d}.hs-garage-menu .hs-garage-menu-community i{background:#176e52}';
  document.head.appendChild(menuStyle);
  renderAll();
  async function loadGarageLinks(){
    if(garageLoaded||garageLoading)return;
    garageLoading=true;
    try{
      var response=await fetch('/apps/garage/account/garage-data',{credentials:'same-origin',headers:{Accept:'application/json'}});
      var data=await readJson(response);
      if(!response.ok)throw new Error('Garage laden mislukt');
      garageLinks=(data.vehicles||[]).filter(function(v){return v.privacyStatus==='public'&&v.moderationStatus==='published';}).map(function(v){return {title:v.title||[v.brand,v.model,v.variant].filter(Boolean).join(' '),url:v.publicUrl||v.url||(v.slug?'/apps/garage/public/builds/'+encodeURIComponent(v.slug):'')};}).filter(function(v){return v.url;});
      garageLoaded=true;
    }catch(error){}finally{garageLoading=false;renderAll();}
  }
  function garageMenu(){
    var onlineLabel='<i aria-hidden="true">↗</i><span>Bekijk mijn online garage</span>';
    var online=garageLinks.length>1?'<details><summary>'+onlineLabel+'</summary>'+garageLinks.map(function(v){return '<a href="'+escapeHtml(v.url)+'">'+escapeHtml(v.title)+'</a>';}).join('')+'</details>':garageLinks.length===1?'<a href="'+escapeHtml(garageLinks[0].url)+'">'+onlineLabel+'</a>':'<a href="/pages/mijn-garage">'+onlineLabel+'<small>'+(garageLoaded?'Nog geen openbare garage': 'Open je garage')+'</small></a>';
    return '<nav class="hs-garage-menu" aria-label="Mijn Garage menu">'+online+'<a class="hs-garage-menu-edit" href="/pages/mijn-garage"><i aria-hidden="true">✎</i><span>Bewerk mijn garage</span></a><a class="hs-garage-menu-community" href="/pages/hs-garage"><i aria-hidden="true">▦</i><span>H&amp;S Garages</span></a></nav>';
  }

  roots.forEach(function (root) {
    if (root.dataset.customerLoggedIn !== 'true') return;

    var toggle = root.querySelector('[data-garage-header-notification-toggle]');
    var panel = root.querySelector('[data-garage-header-notification-panel]');

    if (toggle) {
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        togglePanel(root);
      });
    }

    if (panel) {
      panel.addEventListener('click', function (event) {
        var closeButton = event.target.closest('[data-garage-header-dismiss-notification]');
        if (!closeButton) return;

        event.preventDefault();
        dismissNotification(closeButton.dataset.garageHeaderDismissNotification);
        renderAll();
      });
    }
  });

  document.addEventListener('click', function (event) {
    roots.forEach(function (root) {
      if (root.contains(event.target)) return;
      closePanel(root);
    });
  });

  window.addEventListener('storage', function (event) {
    if (event.key === storageKey) renderAll();
  });

  window.addEventListener('hs-garage:notifications-updated', function (event) {
    if (event.detail && event.detail.source === 'header-read') return;
    renderAll();
  });

  loadNotifications();

  async function loadNotifications() {
    var activeRoot = roots.find(function (root) {
      return root.dataset.customerLoggedIn === 'true';
    });
    if (!activeRoot) return;

    try {
      var appUrl = activeRoot.dataset.appUrl || '/apps/garage/account';
      var response = await fetch(appUrl + '/notifications', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      var payload = await readJson(response);

      if (!response.ok) return;

      notifications = Array.isArray(payload.notifications) ? payload.notifications : [];
      renderAll();
    } catch (error) {
      notifications = [];
      renderAll();
    }
  }

  function renderAll() {
    var visibleNotifications = activeNotifications();

    roots.forEach(function (root) {
      renderRoot(root, visibleNotifications);
    });
  }

  function renderRoot(root, visibleNotifications) {
    var toggle = root.querySelector('[data-garage-header-notification-toggle]');
    var count = root.querySelector('[data-garage-header-notification-count]');
    var countLabel = root.querySelector('[data-garage-header-notification-label]');
    var panel = root.querySelector('[data-garage-header-notification-panel]');

    if (!toggle || !count || !panel || root.dataset.customerLoggedIn !== 'true') return;

    toggle.hidden = false;
    count.textContent = String(Math.min(visibleNotifications.length, 99));
    if (countLabel) countLabel.textContent = visibleNotifications.length === 1 ? 'nieuwe melding' : 'nieuwe meldingen';
    toggle.classList.toggle('is-read', !visibleNotifications.length);
    panel.innerHTML = panelTemplate(visibleNotifications);
  }

  function togglePanel(root) {
    var panel = root.querySelector('[data-garage-header-notification-panel]');
    var toggle = root.querySelector('[data-garage-header-notification-toggle]');
    if (!panel || !toggle) return;

    var shouldOpen = panel.hidden;
    roots.forEach(closePanel);

    panel.hidden = !shouldOpen;
    toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');

    if (shouldOpen) {
      loadGarageLinks();
      markNotificationsRead(activeNotifications());
      roots.forEach(markRootRead);
    }
  }

  function closePanel(root) {
    var panel = root.querySelector('[data-garage-header-notification-panel]');
    var toggle = root.querySelector('[data-garage-header-notification-toggle]');
    if (panel) panel.hidden = true;
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.classList.toggle('is-read', !activeNotifications().length);
    }
  }

  function activeNotifications() {
    return notifications.filter(function (notification) {
      return notification && notification.id && dismissedNotifications().indexOf(String(notification.id)) === -1;
    });
  }

  function panelTemplate(items) {
    var shown = items.slice(0, 5);

    return [
      garageMenu(),
      '<div class="hs-garage-header-alert__head">',
      '<strong>Garage updates</strong>',
      '<span>' + items.length + (items.length === 1 ? ' nieuw' : ' nieuw') + '</span>',
      '</div>',
      shown.length ? '<div class="hs-garage-header-alert__list">' + shown.map(notificationTemplate).join('') + '</div>' : '<div class="hs-garage-header-alert__empty">Geen nieuwe garage-updates.</div>',

    ].join('');
  }

  function notificationTemplate(notification) {
    var id = escapeHtml(notification.id || '');
    var title = escapeHtml(notification.title || 'Garage update');
    var message = escapeHtml(notification.message || '');
    var image = escapeHtml(notification.image || '');
    var url = escapeHtml(notification.url || '/pages/mijn-garage');

    return [
      '<article class="hs-garage-header-alert__item">',
      image ? '<img src="' + image + '" alt="" loading="lazy">' : '<span class="hs-garage-header-alert__icon">' + iconFor(notification.type) + '</span>',
      '<a href="' + url + '">',
      '<strong>' + title + '</strong>',
      message ? '<small>' + message + '</small>' : '',
      '</a>',
      '<button type="button" aria-label="Melding sluiten" data-garage-header-dismiss-notification="' + id + '">&times;</button>',
      '</article>',
    ].join('');
  }

  function iconFor(type) {
    if (type === 'favorite') return '★';
    if (type === 'comment' || type === 'reply') return '“';
    return '♥';
  }

  function dismissedNotifications() {
    try {
      return JSON.parse(localStorage.getItem(storageKey) || '[]');
    } catch (error) {
      return [];
    }
  }

  function dismissNotification(id) {
    if (!id) return;

    try {
      var dismissed = dismissedNotifications();
      if (dismissed.indexOf(String(id)) === -1) {
        dismissed.push(String(id));
        localStorage.setItem(storageKey, JSON.stringify(dismissed.slice(-120)));
      }
    } catch (error) {
      return;
    }
  }

  function markNotificationsRead(items) {
    var ids = (items || []).map(function (notification) {
      return notification && notification.id ? String(notification.id) : '';
    }).filter(Boolean);

    if (!ids.length) return;

    try {
      var dismissed = dismissedNotifications();
      ids.forEach(function (id) {
        if (dismissed.indexOf(id) === -1) dismissed.push(id);
      });
      localStorage.setItem(storageKey, JSON.stringify(dismissed.slice(-120)));
      window.dispatchEvent(new CustomEvent('hs-garage:notifications-updated', { detail: { source: 'header-read' } }));
    } catch (error) {
      return;
    }
  }

  function markRootRead(root) {
    var toggle = root.querySelector('[data-garage-header-notification-toggle]');
    var count = root.querySelector('[data-garage-header-notification-count]');
    var countLabel = root.querySelector('[data-garage-header-notification-label]');
    if (!toggle || !count) return;

    toggle.classList.add('is-read');
    count.textContent = '0';
    if (countLabel) countLabel.textContent = 'nieuwe meldingen';
  }

  async function readJson(response) {
    var text = await response.text();
    if (!text) return {};

    try {
      return JSON.parse(text);
    } catch (error) {
      return {};
    }
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
})();

(function(){
  if(!/\/pages\/hs-garage\/?$/.test(location.pathname))return;
  function finish(){clearTimeout(window.hsGarageMonthLoadingTimer);document.documentElement.classList.remove('hs-month-loading');}
  async function showMonth(){
    var old=document.querySelector('#gc-social .gs-cover');
    if(!old){finish();return;}
    try{
      var data=await (window.hsGarageMonthRequest || fetch('/apps/garage/garage-month',{credentials:'same-origin',headers:{Accept:'application/json'}}).then(function(r){return r.ok?r.json():null;}));
      if(!data||!data.html){finish();return;}
      if(!document.querySelector('link[href*="garage-month-concept.css"]')){
        await new Promise(function(resolve,reject){var css=document.createElement('link');css.rel='stylesheet';css.href='https://hs-garage-production.up.railway.app/garage-month-concept.css?v=live-1';css.onload=resolve;css.onerror=reject;document.head.appendChild(css);});
      }
      var box=document.createElement('div');box.innerHTML=data.html;
      var banner=box.querySelector('.gm-feature');
      if(banner&&old.isConnected)old.replaceWith(banner);
    }catch(error){/* Restore the original banner if the service is unavailable. */}
    finally{finish();}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',showMonth,{once:true});else showMonth();
})();

(function(){
 function garageHeadings(){
  document.querySelectorAll('#gc-social h3').forEach(function(h){if(h.textContent.trim()==='Ontmoet de builds.'){h.textContent='Trending garages';var label=h.parentElement.querySelector('.gs-eyebrow');if(label)label.textContent='Meest bekeken garages';}});
  document.querySelectorAll('#garage-builds h2').forEach(function(h){if(h.textContent.trim()==='Ontdek de builds.')h.textContent='Rol een garagedeur open';});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',garageHeadings,{once:true});else garageHeadings();
})();

(function(){
  function startTrending(){
    var heading=Array.prototype.find.call(document.querySelectorAll('#gc-social h3'),function(h){return /^(Trending garages|Ontmoet de builds\.?)$/.test(h.textContent.trim());});
    if(!heading)return;
    var panel=heading.parentElement;
    if(panel.dataset.liveTrending)return;
    panel.dataset.liveTrending='true';heading.textContent='Trending garages';
    var label=panel.querySelector('.gs-eyebrow');if(label)label.textContent='Meest bekeken garages';
    panel.querySelectorAll('.gs-mini-build').forEach(function(a){a.remove();});
    var list=document.createElement('div');list.setAttribute('aria-label','Meest bekeken openbare garages');
    var status=document.createElement('p');status.textContent='Meest bekeken garages laden…';status.setAttribute('role','status');list.appendChild(status);
    heading.insertAdjacentElement('afterend',list);
    var busy=false,loaded=false,lastRefresh=0,signature='';
    function views(b){var n=Number(b.viewCount);return Number.isFinite(n)?Math.max(0,n):0;}
    async function refresh(){
      if(busy||document.hidden||!panel.isConnected)return;
      busy=true;var controller=new AbortController(),timeout=setTimeout(function(){controller.abort();},12000);
      try{
        var response=await fetch('/apps/garage/public/builds',{credentials:'same-origin',cache:'no-store',signal:controller.signal,headers:{Accept:'application/json'}});
        if(!response.ok)throw Error('Niet beschikbaar');
        var data=await response.json();if(!Array.isArray(data.builds))throw Error('Ongeldige lijst');
        var top=data.builds.filter(function(b){return b.slug;}).sort(function(a,b){return views(b)-views(a)||String(a.slug).localeCompare(String(b.slug));}).slice(0,3);
        var next=JSON.stringify(top.map(function(b){return [b.slug,b.title,b.mainImage,views(b)];}));
        if(next!==signature){
          var fragment=document.createDocumentFragment();
          top.forEach(function(b,index){
            var a=document.createElement('a');a.className='gs-mini-build';a.href='/apps/garage/public/builds/'+encodeURIComponent(b.slug);
            if(b.mainImage){var img=document.createElement('img');img.src=b.mainImage;img.alt=b.mainImageAlt||b.title||'Garagefoto';img.loading='lazy';a.appendChild(img);}
            var span=document.createElement('span'),title=document.createElement('strong'),meta=document.createElement('small');
            title.textContent=(index+1)+'. '+(b.title||'Garage');meta.textContent=views(b).toLocaleString('nl-NL')+' keer bekeken · Bekijk garage ↗';
            span.appendChild(title);span.appendChild(meta);a.appendChild(span);fragment.appendChild(a);
          });
          if(!top.length){var empty=document.createElement('p');empty.textContent='Nog geen openbare garages.';fragment.appendChild(empty);}
          list.replaceChildren(fragment);signature=next;
        }
        loaded=true;lastRefresh=Date.now();
      }catch(error){if(!loaded)status.textContent='De garages kunnen even niet worden geladen. We proberen het opnieuw.';}
      finally{clearTimeout(timeout);busy=false;}
    }
    refresh();
    var interval=setInterval(function(){if(!panel.isConnected){clearInterval(interval);return;}refresh();},60000);
    document.addEventListener('visibilitychange',function(){if(!document.hidden&&Date.now()-lastRefresh>45000)refresh();});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',startTrending,{once:true});else startTrending();
})();
